export default "__VITE_ASSET__CgLfPMnK__"